import { IconLocation } from "src/utils/URLUtils";
import styles from "./XIcon.module.scss";

interface XIconProps {
    onClick?: () => void;
    className?: string;
}

const XIcon = ({ onClick, className = 'XsIcon' }: XIconProps) => {
    return (
        <img
            className={`${styles.xIcon} ${className}`}
            src={IconLocation('x')}
            alt="Close"
            onClick={onClick}
        />
    );
};

export default XIcon;
